/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvitoDTO
 */
export interface InvitoDTO {
    /**
     * 
     * @type {string}
     * @memberof InvitoDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InvitoDTO
     */
    invitatoDa?: string;
    /**
     * 
     * @type {Date}
     * @memberof InvitoDTO
     */
    invitatoIl?: Date;
    /**
     * 
     * @type {string}
     * @memberof InvitoDTO
     */
    email?: string;
    /**
     * 
     * @type {Date}
     * @memberof InvitoDTO
     */
    scadenza?: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof InvitoDTO
     */
    ruoliProposti?: Array<string>;
}

/**
 * Check if a given object implements the InvitoDTO interface.
 */
export function instanceOfInvitoDTO(value: object): value is InvitoDTO {
    return true;
}

export function InvitoDTOFromJSON(json: any): InvitoDTO {
    return InvitoDTOFromJSONTyped(json, false);
}

export function InvitoDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvitoDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'invitatoDa': json['invitatoDa'] == null ? undefined : json['invitatoDa'],
        'invitatoIl': json['invitatoIl'] == null ? undefined : (new Date(json['invitatoIl'])),
        'email': json['email'] == null ? undefined : json['email'],
        'scadenza': json['scadenza'] == null ? undefined : (new Date(json['scadenza'])),
        'ruoliProposti': json['ruoliProposti'] == null ? undefined : json['ruoliProposti'],
    };
}

export function InvitoDTOToJSON(value?: InvitoDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'invitatoDa': value['invitatoDa'],
        'invitatoIl': value['invitatoIl'] == null ? undefined : ((value['invitatoIl']).toISOString()),
        'email': value['email'],
        'scadenza': value['scadenza'] == null ? undefined : ((value['scadenza']).toISOString()),
        'ruoliProposti': value['ruoliProposti'],
    };
}

